/**
 * ODA Global Constants — AUTO-GENERATED
 *
 * Generated from public/DrawingJS/notation.js
 * Types from DrawingModule in src/drawing/types/DrawingWeb.d.ts
 *
 * Do not edit manually. Run: npx tsx script/node/src/sync-oda-constants.ts
 */

type DM = typeof import("../types/DrawingWeb").DrawingModule;

const g = globalThis as Record<string, unknown>;

export const XrefStatus = g["XrefStatus"] as DM["XrefStatus"];
export const LightingModel = g["LightingModel"] as {
  readonly kInvisible: 0;
  readonly kConstant: 1;
  readonly kPhong: 2;
  readonly kGooch: 3;
};
export const LightingQuality = g["LightingQuality"] as {
  readonly kNoLighting: 0;
  readonly kPerFaceLighting: 1;
  readonly kPerVertexLighting: 2;
  readonly kPerPixelLighting: 3;
};
export const FaceColorMode = g["FaceColorMode"] as {
  readonly kNoColorMode: 0;
  readonly kObjectColor: 1;
  readonly kBackgroundColor: 2;
  readonly kMono: 3;
  readonly kTint: 4;
  readonly kDesaturate: 5;
};
export const FaceModifier = g["FaceModifier"] as {
  readonly kNoFaceModifiers: 0;
  readonly kOpacity: 1;
  readonly kSpecular: 2;
};
export const EdgeModel = g["EdgeModel"] as {
  readonly kNoEdges: 0;
  readonly kIsolines: 1;
  readonly kFacetEdges: 2;
};
export const EdgeStyle = g["EdgeStyle"] as {
  readonly kNoEdgeStyle: 0;
  readonly kVisible: 1;
  readonly kSilhouette: 2;
  readonly kObscured: 4;
  readonly kIntersection: 8;
};
export const EdgeModifier = g["EdgeModifier"] as {
  readonly kNoEdgeModifiers: 0;
  readonly kOverhang: 1;
  readonly kJitter: 2;
  readonly kWidth: 4;
  readonly kColor: 8;
  readonly kHaloGap: 16;
  readonly kLinetype: 32;
  readonly kAlwaysOnTop: 64;
  readonly kOpacity: 128;
  readonly kWiggle: 256;
  readonly kTexture: 512;
};
export const JitterAmount = g["JitterAmount"] as {
  readonly kJitterLow: 1;
  readonly kJitterMedium: 2;
  readonly kJitterHigh: 3;
};
export const WiggleAmount = g["WiggleAmount"] as {
  readonly kWiggleLow: 1;
  readonly kWiggleMedium: 2;
  readonly kWiggleHigh: 3;
};
export const LineType = g["LineType"] as {
  readonly kSolid: 1;
  readonly kDashed: 2;
  readonly kDotted: 3;
  readonly kShortDash: 4;
  readonly kMediumDash: 5;
  readonly kLongDash: 6;
  readonly kDoubleShortDash: 7;
  readonly kDoubleMediumDash: 8;
  readonly kDoubleLongDash: 9;
  readonly kMediumLongDash: 10;
  readonly kSparseDot: 11;
};
export const EdgeStyleApply = g["EdgeStyleApply"] as {
  readonly kDefault: 0;
  readonly kAll: 1;
};
export const DisplaySettings = g["DisplaySettings"] as {
  readonly kNone: 0;
  readonly kBackgrounds: 1;
  readonly kLights: 2;
  readonly kMaterials: 4;
  readonly kTextures: 8;
};
export const ShadowType = g["ShadowType"] as {
  readonly kShadowsNone: 0;
  readonly kShadowsGroundPlane: 1;
  readonly kShadowsFull: 2;
  readonly kShadowsFullAndGround: 3;
};
export const Property = g["Property"] as {
  readonly kInvalidProperty: -1;
  readonly kFaceLightingModel: 0;
  readonly kFaceLightingQuality: 1;
  readonly kFaceColorMode: 2;
  readonly kFaceModifiers: 3;
  readonly kFaceOpacity: 4;
  readonly kFaceSpecular: 5;
  readonly kFaceMonoColor: 6;
  readonly kEdgeModel: 7;
  readonly kEdgeStyles: 8;
  readonly kEdgeIntersectionColor: 9;
  readonly kEdgeObscuredColor: 10;
  readonly kEdgeObscuredLinePattern: 11;
  readonly kEdgeIntersectionLinePattern: 12;
  readonly kEdgeCreaseAngle: 13;
  readonly kEdgeModifiers: 14;
  readonly kEdgeColor: 15;
  readonly kEdgeOpacity: 16;
  readonly kEdgeWidth: 17;
  readonly kEdgeOverhang: 18;
  readonly kEdgeJitterAmount: 19;
  readonly kEdgeSilhouetteColor: 20;
  readonly kEdgeSilhouetteWidth: 21;
  readonly kEdgeHaloGap: 22;
  readonly kEdgeIsolines: 23;
  readonly kEdgeHidePrecision: 24;
  readonly kDisplayStyles: 25;
  readonly kDisplayBrightness: 26;
  readonly kDisplayShadowType: 27;
  readonly kUseDrawOrder: 28;
  readonly kViewportTransparency: 29;
  readonly kLightingEnabled: 30;
  readonly kPosterizeEffect: 31;
  readonly kMonoEffect: 32;
  readonly kBlurEffect: 33;
  readonly kPencilEffect: 34;
  readonly kBloomEffect: 35;
  readonly kPastelEffect: 36;
  readonly kBlurAmount: 37;
  readonly kPencilAngle: 38;
  readonly kPencilScale: 39;
  readonly kPencilPattern: 40;
  readonly kPencilColor: 41;
  readonly kBloomThreshold: 42;
  readonly kBloomRadius: 43;
  readonly kTintColor: 44;
  readonly kFaceAdjustment: 45;
  readonly kPostContrast: 46;
  readonly kPostBrightness: 47;
  readonly kPostPower: 48;
  readonly kTintEffect: 49;
  readonly kBloomIntensity: 50;
  readonly kColor: 51;
  readonly kTransparency: 52;
  readonly kEdgeWiggleAmount: 53;
  readonly kEdgeTexturePath: 54;
  readonly kDepthOfField: 55;
  readonly kFocusDistance: 56;
  readonly kFocusWidth: 57;
  readonly kPropertyCount: 58;
};
export const Operation = g["Operation"] as {
  readonly kInvalidOperation: -1;
  readonly kInherit: 0;
  readonly kSet: 1;
  readonly kDisable: 2;
  readonly kEnable: 3;
};
export const Type = g["Type"] as DM["Type"];
export const FaceLightingModel = g["FaceLightingModel"] as {
  readonly kInvisible: 0;
  readonly kConstant: 1;
  readonly kPhong: 2;
  readonly kGooch: 3;
  readonly kZebra: 4;
};
export const FaceLightingQuality = g["FaceLightingQuality"] as {
  readonly kNoLighting: 0;
  readonly kPerFaceLighting: 1;
  readonly kPerVertexLighting: 2;
  readonly kPerPixelLighting: 3;
};
export const FaceModifiers = g["FaceModifiers"] as {
  readonly kNoFaceModifiers: 0;
  readonly kFaceOpacityFlag: 1;
  readonly kSpecularFlag: 2;
};
export const EdgeStyles = g["EdgeStyles"] as {
  readonly kNoEdgeStyle: 0;
  readonly kVisibleFlag: 1;
  readonly kSilhouetteFlag: 2;
  readonly kObscuredFlag: 4;
  readonly kIntersectionFlag: 8;
};
export const EdgeModifiers = g["EdgeModifiers"] as {
  readonly kNoEdgeModifiers: 0;
  readonly kEdgeOverhangFlag: 1;
  readonly kEdgeJitterFlag: 2;
  readonly kEdgeWidthFlag: 4;
  readonly kEdgeColorFlag: 8;
  readonly kEdgeHaloGapFlag: 16;
  readonly kAlwaysOnTopFlag: 64;
  readonly kEdgeOpacityFlag: 128;
  readonly kEdgeWiggleFlag: 256;
  readonly kEdgeTextureFlag: 512;
  readonly kEdgeLinetypeFlag: 1024;
  readonly kSilhLinetypeFlag: 2048;
};
export const EdgeJitterAmount = g["EdgeJitterAmount"] as {
  readonly kJitterLow: 1;
  readonly kJitterMedium: 2;
  readonly kJitterHigh: 3;
};
export const EdgeWiggleAmount = g["EdgeWiggleAmount"] as {
  readonly kWiggleLow: 1;
  readonly kWiggleMedium: 2;
  readonly kWiggleHigh: 3;
};
export const EdgeLinePattern = g["EdgeLinePattern"] as {
  readonly kSolid: 1;
  readonly kDashedLine: 2;
  readonly kDotted: 3;
  readonly kShortDash: 4;
  readonly kMediumDash: 5;
  readonly kLongDash: 6;
  readonly kDoubleShortDash: 7;
  readonly kDoubleMediumDash: 8;
  readonly kDoubleLongDash: 9;
  readonly kMediumLongDash: 10;
  readonly kSparseDot: 11;
};
export const DisplayStyles = g["DisplayStyles"] as {
  readonly kNoDisplayStyle: 0;
  readonly kBackgroundsFlag: 1;
  readonly kLightingFlag: 2;
  readonly kMaterialsFlag: 4;
  readonly kTexturesFlag: 8;
};
export const DisplayShadowType = g["DisplayShadowType"] as {
  readonly kShadowsNone: 0;
  readonly kShadowsGroundPlane: 1;
  readonly kShadowsFull: 2;
  readonly kShadowsFullAndGround: 3;
};
export const Direction = g["Direction"] as DM["Direction"];
export const GripModes = g["GripModes"] as DM["GripModes"];
export const OdResult = g["OdResult"] as DM["OdResult"];
export const OdMessage = g["OdMessage"] as DM["OdMessage"];
export const RotatedDimType = g["RotatedDimType"] as DM["RotatedDimType"];
export const PointType = g["PointType"] as DM["PointType"];
export const AssocFlags = g["AssocFlags"] as DM["AssocFlags"];
export const ClipBoundaryType = g["ClipBoundaryType"] as DM["ClipBoundaryType"];
export const ImageDisplayOpt = g["ImageDisplayOpt"] as DM["ImageDisplayOpt"];
export const OdGeIslandStyle = g["OdGeIslandStyle"] as DM["OdGeIslandStyle"];
export const BlockScaling = g["BlockScaling"] as DM["BlockScaling"];
export const LoopType = g["LoopType"] as DM["LoopType"];
export const Units = g["Units"] as DM["Units"];
export const ImageSource = g["ImageSource"] as DM["ImageSource"];
export const TransparencyMode = g["TransparencyMode"] as DM["TransparencyMode"];
export const ParamType = g["ParamType"] as DM["ParamType"];
export const ExternalEntityKind = g[
  "ExternalEntityKind"
] as DM["ExternalEntityKind"];
export const PointContainment = g["PointContainment"] as DM["PointContainment"];
export const NurbSurfaceProperties = g[
  "NurbSurfaceProperties"
] as DM["NurbSurfaceProperties"];
export const OdGeXConfig = g["OdGeXConfig"] as DM["OdGeXConfig"];
export const BooleanType = g["BooleanType"] as DM["BooleanType"];
export const ClipError = g["ClipError"] as DM["ClipError"];
export const ClipCondition = g["ClipCondition"] as DM["ClipCondition"];
export const csiConfig = g["csiConfig"] as DM["csiConfig"];
export const ssiType = g["ssiType"] as DM["ssiType"];
export const ssiConfig = g["ssiConfig"] as DM["ssiConfig"];
export const OdGeIntersectError = g[
  "OdGeIntersectError"
] as DM["OdGeIntersectError"];
export const OdGeKnotParameterization = g[
  "OdGeKnotParameterization"
] as DM["OdGeKnotParameterization"];
export const EntityId = g["EntityId"] as DM["EntityId"];
export const OffsetCrvExtType = g["OffsetCrvExtType"] as DM["OffsetCrvExtType"];
export const ErrorCondition = g["ErrorCondition"] as DM["ErrorCondition"];
export const Poly3dType = g["Poly3dType"] as DM["Poly3dType"];
export const OdRxObjMod = g["OdRxObjMod"] as DM["OdRxObjMod"];
export const Ordering = g["Ordering"] as DM["Ordering"];
export const MTSupport = g["MTSupport"] as DM["MTSupport"];
export const OverrulingType = g["OverrulingType"] as DM["OverrulingType"];
export const FileAccessMode = g["FileAccessMode"] as DM["FileAccessMode"];
export const FileShareMode = g["FileShareMode"] as DM["FileShareMode"];
export const FileCreationDisposition = g[
  "FileCreationDisposition"
] as DM["FileCreationDisposition"];
export const FilerSeekType = g["FilerSeekType"] as DM["FilerSeekType"];
export const ProdIdCode = g["ProdIdCode"] as DM["ProdIdCode"];
export const FindFileHint = g["FindFileHint"] as DM["FindFileHint"];
export const OdSDIValues = g["OdSDIValues"] as DM["OdSDIValues"];
export const RemapFileContext = g["RemapFileContext"] as DM["RemapFileContext"];
export const GsBitmapDeviceFlags = g[
  "GsBitmapDeviceFlags"
] as DM["GsBitmapDeviceFlags"];
export const TableBreakOption = g["TableBreakOption"] as DM["TableBreakOption"];
export const TableBreakFlowDirection = g[
  "TableBreakFlowDirection"
] as DM["TableBreakFlowDirection"];
export const TableHitItem = g["TableHitItem"] as DM["TableHitItem"];
export const TableStyleOverrides = g[
  "TableStyleOverrides"
] as DM["TableStyleOverrides"];
export const EndCaps = g["EndCaps"] as DM["EndCaps"];
export const JoinStyle = g["JoinStyle"] as DM["JoinStyle"];
export const DuplicateLinetypeLoading = g[
  "DuplicateLinetypeLoading"
] as DM["DuplicateLinetypeLoading"];
export const TimeZone = g["TimeZone"] as DM["TimeZone"];
export const LoftParamType = g["LoftParamType"] as DM["LoftParamType"];
export const LoftNormalsType = g["LoftNormalsType"] as DM["LoftNormalsType"];
export const CollisionType = g["CollisionType"] as DM["CollisionType"];
export const ProxyImage = g["ProxyImage"] as DM["ProxyImage"];
export const TextFileEncoding = g["TextFileEncoding"] as DM["TextFileEncoding"];
export const LayerAdskType = g["LayerAdskType"] as DM["LayerAdskType"];
export const FilletTrimMode = g["FilletTrimMode"] as DM["FilletTrimMode"];
export const IndexingModeFlags = g[
  "IndexingModeFlags"
] as DM["IndexingModeFlags"];
export const VerticalApplicationMode = g[
  "VerticalApplicationMode"
] as DM["VerticalApplicationMode"];
export const VerticalApplicationType = g[
  "VerticalApplicationType"
] as DM["VerticalApplicationType"];
export const Poly2dType = g["Poly2dType"] as DM["Poly2dType"];
export const PlotPaperUnits = g["PlotPaperUnits"] as DM["PlotPaperUnits"];
export const PlotRotation = g["PlotRotation"] as DM["PlotRotation"];
export const PlotType = g["PlotType"] as DM["PlotType"];
export const StdScaleType = g["StdScaleType"] as DM["StdScaleType"];
export const ShadePlotType = g["ShadePlotType"] as DM["ShadePlotType"];
export const ShadePlotResLevel = g[
  "ShadePlotResLevel"
] as DM["ShadePlotResLevel"];
export const EdgeExtensionType = g[
  "EdgeExtensionType"
] as DM["EdgeExtensionType"];
export const AfTypeVerEnum = g["AfTypeVerEnum"] as DM["AfTypeVerEnum"];
export const BoolOperType = g["BoolOperType"] as DM["BoolOperType"];
export const ColorConversionType = g[
  "ColorConversionType"
] as DM["ColorConversionType"];
export const AttachmentPoint = g["AttachmentPoint"] as DM["AttachmentPoint"];
export const FlowDirection = g["FlowDirection"] as DM["FlowDirection"];
export const BaseTextHeightRTF = g[
  "BaseTextHeightRTF"
] as DM["BaseTextHeightRTF"];
export const ColumnType = g["ColumnType"] as DM["ColumnType"];
export const SplineType = g["SplineType"] as DM["SplineType"];
export const ContentType = g["ContentType"] as DM["ContentType"];
export const DrawMLeaderOrderType = g[
  "DrawMLeaderOrderType"
] as DM["DrawMLeaderOrderType"];
export const DrawLeaderOrderType = g[
  "DrawLeaderOrderType"
] as DM["DrawLeaderOrderType"];
export const LeaderType = g["LeaderType"] as DM["LeaderType"];
export const TextAttachmentDirection = g[
  "TextAttachmentDirection"
] as DM["TextAttachmentDirection"];
export const TextAttachmentType = g[
  "TextAttachmentType"
] as DM["TextAttachmentType"];
export const TextAngleType = g["TextAngleType"] as DM["TextAngleType"];
export const TextAlignmentType = g[
  "TextAlignmentType"
] as DM["TextAlignmentType"];
export const BlockConnectionType = g[
  "BlockConnectionType"
] as DM["BlockConnectionType"];
export const LeaderDirectionType = g[
  "LeaderDirectionType"
] as DM["LeaderDirectionType"];
export const SegmentAngleType = g["SegmentAngleType"] as DM["SegmentAngleType"];
export const DimArrowFlags = g["DimArrowFlags"] as {
  readonly kFirstArrow: 0;
  readonly kSecondArrow: 1;
};
export const VariantType = g["VariantType"] as {
  readonly kUndefined: 0;
  readonly kBoolean: 1;
  readonly kInt: 2;
  readonly kDouble: 3;
  readonly kColor: 4;
  readonly kString: 5;
  readonly kTable: 6;
};
export const DrawableType = g["DrawableType"] as DM["DrawableType"];
export const SetAttributesFlags = g[
  "SetAttributesFlags"
] as DM["SetAttributesFlags"];
export const Vertex3dType = g["Vertex3dType"] as DM["Vertex3dType"];
export const TextHorzMode = g["TextHorzMode"] as DM["TextHorzMode"];
export const TextVertMode = g["TextVertMode"] as DM["TextVertMode"];
export const LineSpacingStyle = g["LineSpacingStyle"] as DM["LineSpacingStyle"];
export const ValueType = g["ValueType"] as DM["ValueType"];
export const PatternBehavior = g["PatternBehavior"] as DM["PatternBehavior"];
export const Mode = g["Mode"] as DM["Mode"];
export const DuplicateRecordCloning = g[
  "DuplicateRecordCloning"
] as DM["DuplicateRecordCloning"];
export const Visibility = g["Visibility"] as DM["Visibility"];
export const SaveType = g["SaveType"] as DM["SaveType"];
export const MaxFlag = g["MaxFlag"] as DM["MaxFlag"];
export const MinFlag = g["MinFlag"] as DM["MinFlag"];
export const NullFlag = g["NullFlag"] as DM["NullFlag"];
export const EMetafilePlayMode = g[
  "EMetafilePlayMode"
] as DM["EMetafilePlayMode"];
export const StandardScaleType = g[
  "StandardScaleType"
] as DM["StandardScaleType"];
export const DictIterType = g["DictIterType"] as DM["DictIterType"];
export const ConnectionSide = g["ConnectionSide"] as DM["ConnectionSide"];
export const InvalidationHint = g["InvalidationHint"] as DM["InvalidationHint"];
export const RenderType = g["RenderType"] as DM["RenderType"];
export const SegType = g["SegType"] as DM["SegType"];
export const DeleteImageEvent = g["DeleteImageEvent"] as DM["DeleteImageEvent"];
export const OwnershipFlag = g["OwnershipFlag"] as DM["OwnershipFlag"];
export const OpenMode = g["OpenMode"] as DM["OpenMode"];
export const GeomType = g["GeomType"] as DM["GeomType"];
export const SubentSelectionMode = g[
  "SubentSelectionMode"
] as DM["SubentSelectionMode"];
export const MaterialDefaultType = g[
  "MaterialDefaultType"
] as DM["MaterialDefaultType"];
export const DragStat = g["DragStat"] as DM["DragStat"];
export const GripStat = g["GripStat"] as DM["GripStat"];
export const DrawType = g["DrawType"] as DM["DrawType"];
export const GripStatus = g["GripStatus"] as DM["GripStatus"];
export const OsnapMask = g["OsnapMask"] as DM["OsnapMask"];
export const GripFlags = g["GripFlags"] as DM["GripFlags"];
export const GripContextFlags = g["GripContextFlags"] as DM["GripContextFlags"];
export const GetGripPointsFlags = g[
  "GetGripPointsFlags"
] as DM["GetGripPointsFlags"];
export const MoveGripPointsFlags = g[
  "MoveGripPointsFlags"
] as DM["MoveGripPointsFlags"];
export const IntersectionStatus = g[
  "IntersectionStatus"
] as DM["IntersectionStatus"];
export const PolyMeshType = g["PolyMeshType"] as DM["PolyMeshType"];
export const DeepCloneType = g["DeepCloneType"] as DM["DeepCloneType"];
export const OdDbProxyCloningOverride = g[
  "OdDbProxyCloningOverride"
] as DM["OdDbProxyCloningOverride"];
export const DwgVersion = g["DwgVersion"] as DM["DwgVersion"];
export const MaintReleaseVer = g["MaintReleaseVer"] as DM["MaintReleaseVer"];
export const LineWeight = g["LineWeight"] as DM["LineWeight"];
export const PlotStyleNameType = g[
  "PlotStyleNameType"
] as DM["PlotStyleNameType"];
export const MultiThreadedMode = g[
  "MultiThreadedMode"
] as DM["MultiThreadedMode"];
export const MeasurementValue = g["MeasurementValue"] as DM["MeasurementValue"];
export const UnitsValue = g["UnitsValue"] as DM["UnitsValue"];
export const Intersect = g["Intersect"] as DM["Intersect"];
export const OsnapMode = g["OsnapMode"] as DM["OsnapMode"];
export const ReferenceType = g["ReferenceType"] as DM["ReferenceType"];
export const whichLine = g["whichLine"] as DM["whichLine"];
export const WatermarkFonts = g["WatermarkFonts"] as DM["WatermarkFonts"];
export const WatermarkPosition = g[
  "WatermarkPosition"
] as DM["WatermarkPosition"];
export const PRCSupport = g["PRCSupport"] as DM["PRCSupport"];
export const PDFAccessPermissionsFlags = g[
  "PDFAccessPermissionsFlags"
] as DM["PDFAccessPermissionsFlags"];
export const PDF_A_mode = g["PDF_A_mode"] as DM["PDF_A_mode"];
export const PDFExportFlags = g["PDFExportFlags"] as DM["PDFExportFlags"];
export const ExportHatchesType = g[
  "ExportHatchesType"
] as DM["ExportHatchesType"];
export const SearchableTextType = g[
  "SearchableTextType"
] as DM["SearchableTextType"];
export const ColorPolicy = g["ColorPolicy"] as DM["ColorPolicy"];
export const PDFShadedViewportExportMode = g[
  "PDFShadedViewportExportMode"
] as DM["PDFShadedViewportExportMode"];
export const PDFMeasuringType = g["PDFMeasuringType"] as DM["PDFMeasuringType"];
export const HatchPatternType = g["HatchPatternType"] as DM["HatchPatternType"];
export const HatchStyle = g["HatchStyle"] as DM["HatchStyle"];
export const HatchObjectType = g["HatchObjectType"] as DM["HatchObjectType"];
export const GradientPatternType = g[
  "GradientPatternType"
] as DM["GradientPatternType"];
export const HatchPatternTypeClosure = g[
  "HatchPatternTypeClosure"
] as DM["HatchPatternTypeClosure"];
export const HatchLoopType = g["HatchLoopType"] as DM["HatchLoopType"];
export const HatchEdgeType = g["HatchEdgeType"] as DM["HatchEdgeType"];
export const SubentType = g["SubentType"] as DM["SubentType"];
export const PDFFormatVersions = g[
  "PDFFormatVersions"
] as DM["PDFFormatVersions"];
export const Convert2dPlane = g["Convert2dPlane"] as DM["Convert2dPlane"];
export const DimInspect = g["DimInspect"] as DM["DimInspect"];
export const Method = g["Method"] as DM["Method"];
export const DwgDataType = g["DwgDataType"] as DM["DwgDataType"];
export const DrawableDescFlags = g[
  "DrawableDescFlags"
] as DM["DrawableDescFlags"];
export const Vertex2dType = g["Vertex2dType"] as DM["Vertex2dType"];
export const RenderMode = g["RenderMode"] as DM["RenderMode"];
export const Projection = g["Projection"] as DM["Projection"];
export const SelectionMode = g["SelectionMode"] as DM["SelectionMode"];
export const DefaultLightingType = g[
  "DefaultLightingType"
] as DM["DefaultLightingType"];
export const ClearColor = g["ClearColor"] as DM["ClearColor"];
export const ViewUpdateFlags = g["ViewUpdateFlags"] as DM["ViewUpdateFlags"];
export const ViewportFlags = g["ViewportFlags"] as DM["ViewportFlags"];
export const ColorMethod = g["ColorMethod"] as DM["ColorMethod"];
export const transparencyMethod = g[
  "transparencyMethod"
] as DM["transparencyMethod"];
export const Color = g["Color"] as DM["Color"];
export const ACIcolorMethod = g["ACIcolorMethod"] as DM["ACIcolorMethod"];
export const Planarity = g["Planarity"] as DM["Planarity"];
export const VisualStyleType = g["VisualStyleType"] as DM["VisualStyleType"];
export const EntSaveAsType = g["EntSaveAsType"] as DM["EntSaveAsType"];
export const MoveType = g["MoveType"] as DM["MoveType"];
export const PropertyOverrideType = g[
  "PropertyOverrideType"
] as DM["PropertyOverrideType"];
export const LeaderLineOverrideType = g[
  "LeaderLineOverrideType"
] as DM["LeaderLineOverrideType"];
export const gsMarkType = g["gsMarkType"] as DM["gsMarkType"];
export const OrthographicView = g["OrthographicView"] as DM["OrthographicView"];
export const AnnoType = g["AnnoType"] as DM["AnnoType"];
export const AssocArraySkipOdaSpecificFlags = g[
  "AssocArraySkipOdaSpecificFlags"
] as DM["AssocArraySkipOdaSpecificFlags"];
